import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import { QueryParamsRefundType, ResponseGetRefundType } from './type';

export const refundApi = createApi({
  reducerPath: 'refundApi',
  tagTypes: ['Refund'],
  refetchOnReconnect: true,
  keepUnusedDataFor: 15,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getRefund: build.query<ResponseGetRefundType, QueryParamsRefundType>({
      query: ({ page, per_page, search }) => ({
        url: '/customer-refund-requests',
        method: 'GET',
        params: { page, per_page, search },
      }),
      providesTags: () => ['Refund'],
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 1) {
          return newItems;
        }

        if (currentCache && newItems.data?.items) {
          return {
            ...newItems,
            data: {
              ...newItems.data,
              items: [...(currentCache.data?.items || []), ...newItems.data.items],
            },
          };
        }
        return newItems;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),
    approveRefund: build.mutation<void, { refundId: number }>({
      query: ({ refundId }) => ({
        url: `/customer-refund-requests/${refundId}/approve`,
        method: 'POST',
      }),
      async onQueryStarted({ refundId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch {
          return;
        }
        dispatch(
          refundApi.util.updateQueryData(
            'getRefund',
            { page: 1, per_page: 50 },
            (draft) => {
              const item = draft.data?.items?.find((i) => i.id === refundId);
              if (item) item.is_approved = true;
            },
          ),
        );
      },
    }),
  }),
});

export const { useGetRefundQuery, useApproveRefundMutation } = refundApi;
